<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card class="mb-5">
    <DialogNearestBanks ref="dialogNearestBanks"></DialogNearestBanks>
  <v-layout row wrap justify-center class="">
    <v-flex xs12>
      <v-card class="ma-3">
        <v-data-table
          select-all
          class="elevation-1 edoFixedHeaderInTable colorrows"
          :headers="headersBL"
          :items="tableDataBL"
          :pagination.sync="pagination"
          v-model="selected"
          hide-actions
          item-key="name"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #004884; color:white">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[getClassFor(header) + ' column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
                style="background-color: #004884; color:white"
              >
                <v-icon small color="white">arrow_upward</v-icon>
                {{ header.text }}
              </th>
              <th style="float: left; background-color: #004884; color:white">
                <v-layout row class="pt-3">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" small color="white">email</v-icon>
                    </template>
                    <span>{{ 'TABLE_CELL_ACTION_EMAIL_NOTIFY' | translate}}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-checkbox
                        v-on="on"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                        hide-details
                        dark
                        @click.stop="toggleAll"
                        color="white"
                        class="ml-3"
                      >
                      </v-checkbox>
                    </template>
                    <span>{{ 'TABLE_CELL_ACTION_EMAIL_NOTIFY' | translate}}</span>
                  </v-tooltip>

                </v-layout>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td :class="getClassFor(header)" v-for="header in headersBL" :key="header.id">
                <span @click="openItem(props.item)" v-if="header.value != 'email'" v-html="getValue(props.item, header)"></span>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="header.value === 'action'"
                            small
                            v-on="on"
                            @click="deleteItem(props.item)"
                    >
                      delete
                    </v-icon>
                  </template>
                  <span>{{ 'TABLE_CELL_ACTION_DELETE' | translate}}</span>
                </v-tooltip>

              </td>
              <td>
                <v-layout row>
                  <v-icon small style="opacity: 0">email</v-icon>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-checkbox v-on="on" label='' primary hide-details v-model="props.selected"
                                  @change="saveEmailNotification(props.item)" color="#004884" class="ml-3"></v-checkbox>
                    </template>
                    <span>{{ 'TABLE_CELL_ACTION_EMAIL_NOTIFY' | translate}}</span>
                  </v-tooltip>

                </v-layout>
              </td>
            </tr>
          </template>
          <!--
          <template slot="expand" slot-scope="props">
            <v-card flat>
              <v-card-text>Peek-a-boo!</v-card-text>
            </v-card>
          </template>
          -->
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
  </v-card>
</template>

<script>
import moment from 'moment'
import DialogNearestBanks from '@/components/module/dialogs/DialogNearestBanks'
import Vue from 'vue'

var _ = require('lodash')

export default {
  name: 'NewsboxFavourites',
  components: {DialogNearestBanks},
  methods: {
    showGroup (item) {
      if (item.diffText !== null) {
        return true
      }
      return false
    },
    setEmailNotification: function (item, isEmail) {
      Vue.prototype.$api.debug('setEmailNotification', item, isEmail)
      if (isEmail) {
        item.email = '1'
      } else {
        item.email = '0'
      }
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.updateChangeLogs(item, this.onGetUpdate, this.onGetUpdate)
    },
    saveEmailNotification: function (item) {
      Vue.prototype.$api.debug('saveEmailNotification', item)
      if (!item.isEmail) {
        item.email = '1'
        this.setEmailNotification(item, true)
      } else {
        item.email = '0'
        this.setEmailNotification(item, false)
      }
    },
    onGetUpdate (data) {
      Vue.prototype.$api.debug('onGetUpdate')
      Vue.prototype.$api.hideIdle()
      this.onChangeLogs()
    },
    toggleAll () {
      if (this.selected.length) {
        for (var index in this.selected) {
          var item = this.selected[index]
          console.log('tg off', item)
          this.setEmailNotification(item, false)
        }
        this.selected = []
      } else {
        this.selected = this.tableDataBL.slice()
        for (var index1 in this.selected) {
          var item1 = this.selected[index1]
          console.log('tg on', item)
          this.setEmailNotification(item1, true)
        }
      }
    },
    dayDiff (date1, date2) {
      let dayDifference = date1.diff(date2, 'days')
      return dayDifference
    },
    downloadDocumentWithTypExists (docType, row) {
      var value = row['docTypes']
      var result = []
      if (value) {
        result = value.split(',')
        if (!result) {
          result = []
        }
      }
      var found = false
      _.forEach(result, function (head) {
        if (docType === head) {
          found = true
        }
      })
      return found
    },
    parseDate: function (dateStr) {
      var d = moment(dateStr)
      return d
    },
    changeSort: function (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    /* Favoriten */
    onGetChangelogBL: function (data) {
      Vue.prototype.$api.debug('onGetChangelogBL', data)
      if (data.array === null) {
        data.array = []
      }
      this.tableDataBL = data.array
      for (var index in this.tableDataBL) {
        var item = this.tableDataBL[index]
        item.isEmail = item.email === '1'
        if (item.isEmail) {
          this.selected.push(item)
        }
      }
      Vue.prototype.$api.hideIdle()
    },
    openItem (item) {
      // abschlussartNr und CrefoNr ist vorhanden, alles andere ist undefind
      var xbalance = {
        aaNr: item.AbschlussartNr,
        crefoNr: item.CrefoNr,
        rkNr: item.RechtskreisNr,
        source: item.QuelleNr,
        year: item.Jahr
      }
      var balance = {
        aaNr: 0,
        crefoNr: item.CrefoNr,
        rkNr: 0,
        source: 0,
        year: 0
      }
      console.log(item, balance)
      // var url = '/Forward?url=' + Vue.prototype.$api.getStructureUrl(item.modulID, balance)
      // Vue.prototype.$api.debug('url', url, item)
      var cmp = this

      var result = Vue.prototype.$api.createSearchDataFromFieldsWithCrefoNr(cmp, cmp.headerFields, item.CrefoNr, Vue.prototype.$api.getModuleId())
      Vue.prototype.$api.searchNearestBanks(result.searchData, cmp.onGetNearestBank, Vue.prototype.$api.onFailure)


      // this.$router.push(url)
      this.currentItem = item
    },
    onGetNearestBank: function (data) {
      Vue.prototype.$api.debug('onGetNearestBank', data, this.idModule)
      this.idModule = Vue.prototype.$api.getModuleId()
      if (data.table.rows.length < 1) {
        var balance = {
          aaNr: '0',
          crefoNr: this.currentCrefoNr,
          rkNr: '0',
          source: '0',
          year: '0'
        }
        Vue.prototype.$api.debug('open balance', balance)

        this.$router.push(Vue.prototype.$api.getStructureUrl(this.idModule, balance))
        return
      }
      if (data.table.rows.length === 1) {
        var balance = data.table.rows[0].balance
        var url = '/Forward?url=' + Vue.prototype.$api.getStructureUrl(this.idModule, balance)
        Vue.prototype.$api.debug('url', url)
        this.$router.push({ path:url, meta: {
            forward: true
          }})
      } else {
        this.$refs.dialogNearestBanks.show(data)
      }
    },
    getValue (item, _header) {
      var value = item[_header.value]
      if (_header.value === 'RechtskreisNr') {
        var e = Vue.prototype.$api.getI18NRechtsKreis(item.RechtskreisNr)
        if (e) value = e.title
      }
      if (_header.value === 'Aenderungsgrund') {
        e = Vue.prototype.$api.getI18NAenderungsgrund(item.Aenderungsgrund)
        if (e) value = e.title
      }
      if (_header.value === 'QuelleNr') {
        e = Vue.prototype.$api.getI18NQuelle(item.QuelleNr)
        if (e) value = e.lanValue
      }
      if (_header.value === 'branch') {
        e = Vue.prototype.$api.getI18NBranche(item.branch)
        if (e) value = e.title
      }
      /*
      if (_header.value === 'country') {
        e = Vue.prototype.$api.getI18NCountry(item.country)
        if (e) {
          return e.title
        }
      }
      if (_header.value === 'region') {
        e = Vue.prototype.$api.getI18NRegion(item.region)
        if (e) {
          return e.title
        }
      }
       */
      if (_header.value === 'datumZeit') {
        if (value) {
          return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
      }

      if (_header.value === 'docTypes') {
        var types = value.split(',')
        var html = ''
        for (var index in types) {
          var items = types[index]
          // html = html + '<img style="margin-right:10px;padding-top:4px; height:20px;" src="static/pdf.png"/>'
          // html = html + '<span class="tableDownloadPDF handpointer" key="index" documentIndex="index" text="item.DokumententypNr + item.year+ item.label" title="item.DokumententypNr + item.year+ item.label"> <v-icon>get_app</v-icon></span>'
        }
        return html
        //
      }
      if (_header.value === 'AbschlussartNr') {
        e = Vue.prototype.$api.getI18NAbschlussart(item.AbschlussartNr)
        if (e) value = e.title
      }
      if (_header.value === 'balanceSum') {
        if (!Number.isFinite(value)) {
          var maximumFractionDigits = 2
          var minimumFractionDigits = 2
          value = (1 * value).toLocaleString('de-DE', {
            style: 'decimal',
            useGrouping: true,
            maximumFractionDigits: maximumFractionDigits,
            minimumFractionDigits: minimumFractionDigits
          })
        }
      }
      if (item.isAnkerBank) {
        var v = value
        if (!v) v = ''
        return '<b>' + v + '</b>'
      }
      return value
    },
    onGetBankData (item) {
      Vue.prototype.$api.debug('onGetBankData', item, this.currentItem)
      Vue.prototype.$api.hideIdle()
      var param = {
        year: '' + this.currentItem.Jahr,
        crefoNr: this.currentItem.CrefoNr,
        bankBalanceDate: item.bilanzDate,
        balanceDate: item.bilanzDate,
        rechtskreis: this.currentItem.RechtskreisNr,
        abschlussart: this.currentItem.AbschlussartNr,
        guid: item.bankID,
        isForwardItem: true,
        hasAnkerbank: false,
        bankCurrency: item.bankCurrency + '',
        currency: item.bankCurrency + '',
        currencyDim: item.bankCurrencyDim + '',
        country: this.currentItem.country,
        region: this.currentItem.region,
        balanceSum: item.bankBalanceSums,
        orderNr: item.orderNr,
        sourceNr: item.sourceNr,
        ultimateMother: item.ultimateMother,
        lastChanged: item.lastChanged,
        name: this.currentItem.name,
        branch: this.currentItem.BranchenkategorieNr
      }
      item.isAnkerbank = true
      Vue.prototype.storage.ankerBank = param
      this.$router.push({name: 'AnkerbankDetails', params: param})
    },
    onSetNotificationDone () {
      Vue.prototype.$api.hideIdle()
      this.onChangeLogs()
    },
    deleteItem (item) {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.setAlertFunction(this, item.CrefoNr, false, this.onSetNotificationDone, this.onSetNotificationDone)
    },
    getHeaderClass (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    },
    getUrlPDF (orderId, type) {
      var urlPDF = Vue.prototype.storage.host() + '/ajaxGetBankOrderAsPDF.php?type=' + type + '&orderId=' + orderId
      urlPDF = urlPDF
      Vue.prototype.$api.debug('this.config.urlPDF', urlPDF)
      return urlPDF
    },
    getClassFor (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    },
    open: function () {
    },
    onChangeLogs: function () {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getChangeLogBL(this.onGetChangelogBL, this.onGetChangelogs)
    }
  },
  data () {
    return {
      currentItem: null,
      cellspan: 6,
      ankerBank: null,
      tabModel: 0,
      hasAnkerBank: false,
      emailSet: [
        {text: Vue.i18n.translate('EMAIL_JA'), id: '1'},
        {text: Vue.i18n.translate('EMAIL_NEIN'), id: '0'}
      ],
      // Name, CrefoNr./HGP-Nr., Region, Land, E-Mail-Benachrichtigung (an/aus)
      crefoDoubleExists: false,
      pagination: {
        rowsPerPage: 5000,
        descending: true,
        sortBy: 'year'
      },
      tableData: [],
      headerFields: [{'id': 'companyName', 'type': 'nm', 'orderNr': '0', 'name': 'Name des Unternehmens'}, {
        'id': 'rk',
        'type': 'nm',
        'orderNr': '1',
        'name': 'Rechtskreis'
      }, {'id': 'aa', 'type': 'nm', 'orderNr': '2', 'name': 'Abschlussart'}, {
        'id': 'year',
        'type': 'nm',
        'orderNr': '4',
        'name': 'Jahr'
      }, {
        'id': 'source',
        'type': 'nm',
        'orderNr': '5',
        'name': 'Quelle'
      }],
      tableDataBL: [],
      countries: [],
      selected: [],
      headersBL: [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name'},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr'},
        {text: Vue.i18n.translate('CELL_TITLE_REGION'), value: 'region'},
        {text: Vue.i18n.translate('CELL_TITLE_LAND'), value: 'country'},
        {text: Vue.i18n.translate('CELL_TITLE_DATUM'), value: 'datumZeit'},
        {text: Vue.i18n.translate('CELL_TITLE_BRANCHE'), value: 'branch'},
        {text: Vue.i18n.translate('CELL_TITLE_ACTION'), value: 'action'}
      ]
    }
  },
  mounted () {
    var cmp = this
    cmp.onChangeLogs()
    // console.log('Auftraggber', Vue.prototype.$api.getParamData().clientNr )

    if ((Vue.prototype.$api.getParamData().clientNr + '') === '148') {
      // Favoriten Liste
      this.headersBL = [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name'},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_HGPNR'), value: 'hgpNr', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_REGION'), value: 'region', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_LAND'), value: 'country', sortable: false},
        {text: Vue.i18n.translate('CELL_TITLE_DATE_ADDED'), value: 'datumZeit', sortable: false},
        /* { text: Vue.i18n.translate('CELL_TITLE_BRANCHE'), value: 'branch', sortable: false }, */
        {text: Vue.i18n.translate('CELL_TITLE_ACTION'), value: 'action', sortable: false}
      ]
      this.cellspan = this.headersBL.length
    } else {
      // Favoriten Liste
      this.headersBL = [
        {text: Vue.i18n.translate('CELL_TITLE_NAME'), value: 'name'},
        {text: Vue.i18n.translate('CELL_TITLE_CREFONR'), value: 'CrefoNr', sortable: true},
        {text: Vue.i18n.translate('CELL_TITLE_REGION'), value: 'region', sortable: true},
        {text: Vue.i18n.translate('CELL_TITLE_LAND'), value: 'country', sortable: true},
        {text: Vue.i18n.translate('CELL_TITLE_DATE_ADDED'), value: 'datumZeit', sortable: true},
        /* { text: Vue.i18n.translate('CELL_TITLE_BRANCHE'), value: 'branch', sortable: false }, */
        {text: Vue.i18n.translate('CELL_TITLE_ACTION'), value: 'action', sortable: false}
      ]
      this.cellspan = this.headersBL.length
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/changelog/NewsboxFavourites.vue